import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IPaymentschedule = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width ?? '18'}
            height={props.height ?? '20'}
            style={{ paddingTop: '1px', color: '#00A896' }}
            viewBox="0 0 18 20"
            fill="none"
          >
            <path
              d="M16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V7H16V18Z"
              fill={props.color ?? '#37474F'}
            />
            <path
              d="M12 14.2457C12 14.7525 11.8091 15.1606 11.4273 15.4698C11.0455 15.7759 10.511 15.9592 9.82371 16.0197V17H9.14143V16.0389C8.33134 16.0229 7.62085 15.8858 7.00996 15.6276V14.3652C7.2988 14.5023 7.64575 14.6234 8.0508 14.7286C8.45916 14.8338 8.82271 14.896 9.14143 14.9151V13.4328L8.80777 13.3084C8.1504 13.0598 7.68393 12.7904 7.40837 12.5003C7.13612 12.207 7 11.8452 7 11.4148C7 10.9526 7.18758 10.5732 7.56275 10.2767C7.94124 9.97709 8.46746 9.79538 9.14143 9.73162V9H9.82371V9.71249C10.584 9.74437 11.2712 9.89101 11.8855 10.1524L11.4173 11.2714C10.8994 11.0673 10.3682 10.943 9.82371 10.8984V12.309C10.4711 12.5481 10.9309 12.7553 11.2032 12.9307C11.4788 13.106 11.6796 13.2989 11.8058 13.5093C11.9353 13.7197 12 13.9651 12 14.2457ZM10.501 14.3174C10.501 14.1835 10.4446 14.0703 10.3317 13.9779C10.2188 13.8854 10.0495 13.7898 9.82371 13.691V14.8816C10.2752 14.8083 10.501 14.6202 10.501 14.3174ZM8.499 11.4148C8.499 11.5551 8.5488 11.6714 8.64841 11.7639C8.75133 11.8532 8.91567 11.9456 9.14143 12.0412V10.9175C8.71315 10.9781 8.499 11.1439 8.499 11.4148Z"
              fill={props.color ?? '#37474F'}
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IPaymentschedule;
